import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { IconCardLayout } from 'view/layout/icon-card-layout';
import Lozenge from '@atlaskit/lozenge';
import { token } from '@atlaskit/tokens';
import { AutoScaledImage } from '@atlassian/help-center-common-component/auto-scaled-image';
import i18n from './messages';

export interface Props {
    icon: React.ReactNode;
    name: string;
    email?: string;
    isNew?: boolean;
}

const UserPickerItem: React.FunctionComponent<Props> = ({ icon, name, email, isNew }) => {
    const content = email ? `${name} (${email})` : name;
    const iconComponent = typeof icon === 'string' ? <AutoScaledImage src={icon} alt="" /> : icon;

    return (
        <>
            <UserPickerItemSection>
                <IconCardLayout leftIcon={iconComponent} content={content} iconSize={16} iconMargin={8} padding={0} />
            </UserPickerItemSection>
            {isNew && (
                <UserPickerItemSection marginLeft={token('space.200', '16px')}>
                    <Lozenge appearance="new">
                        <FormattedMessage {...i18n.newUserLozengeText} />
                    </Lozenge>
                </UserPickerItemSection>
            )}
        </>
    );
};

export default UserPickerItem;

interface UserPickerItemSectionProps {
    marginLeft?: string;
}

const UserPickerItemSection = styled.div`
    display: inline-block;
    margin-left: ${(props: UserPickerItemSectionProps) => `${props && props.marginLeft ? props.marginLeft : '0px'}`};
    vertical-align: top;
`;
